import React, {Component, PropTypes} from 'react'
import API from '../../apiClient/v2'
import {Header} from './components/Header.jsx'
import {SelectFilter} from './components/Filters.jsx'
import {TableCalendar} from './components/TableCalendar.jsx'

export class CalendarMaintainer extends Component{
    constructor(props){
        super(props)
        this.state = {
            days : [],
            optionsStatus : [
                {value: 1, text: 'Todos'},
                {value: 2, text: 'Laborables'},
                {value: 3, text: 'No Laborables'}
            ],
            defaultMonth: this.props.months[0].value,
            defaultStatus: "1"
        }
        this.searchingData = (month, statusDays) => {
            API.admin.calendar.getDays(month, statusDays)
                .then(response => {
                    this.setState({
                        days : response,
                        defaultMonth: month,
                        defaultStatus: statusDays
                    })
                })
                .catch(error => console.log(error))
        }
        this.onChangeStatusDay = (day, evt) => {
            const newStatus = evt.target.checked
            API.admin.calendar.updateStatusDay(day, newStatus)
                .then(() => {
                    this.searchingData(this.state.defaultMonth, this.state.defaultStatus)
                })
                .catch(err=>{})
        } 
        this.onSaveCommentDay = (day, value) => {
            API.admin.calendar.updateCommentDay(day, value)
                .then(() => {
                    this.searchingData(this.state.defaultMonth, this.state.defaultStatus)
                })
                .catch(err=>{})
        }
    }
    componentDidMount(){
        this.searchingData(this.state.defaultMonth, this.state.defaultStatus)
    }
    render(){
        return(
            <div className="container-fluid">
                <Header
                    title = "Administración calendario"
                    glyphicon = "glyphicon glyphicon-calendar"
                />
                <div className="row">
                    <div className="col-md-9">
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <span className="glyphicon glyphicon-th-list"></span> 
                            </div>    
                            <div className="panel-body">
                                <TableCalendar
                                    days = {this.state.days}
                                    onChangeStatusDay = {this.onChangeStatusDay}
                                    onSaveCommentDay = {this.onSaveCommentDay}
                                />
                            </div>    
                        </div>
                    </div>
                    <div className="col-md-3">
                        <SelectFilter
                            months = {this.props.months}
                            optionsStatus = {this.state.optionsStatus}
                            defaultMonth = {this.state.defaultMonth}
                            defaultStatus = {this.state.defaultStatus}
                            searchingData = {this.searchingData}
                        />
                    </div>    
                </div>
            </div>
        )
    }
}
CalendarMaintainer.proptypes = {
    months : PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/admin/CalendarMaintainer/CalendarMaintainer.jsx